import { render, staticRenderFns } from "./UpdateGroupLog.vue?vue&type=template&id=1dc2b125&lang=pug&"
import script from "./UpdateGroupLog.vue?vue&type=script&lang=ts&"
export * from "./UpdateGroupLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports